import storeInfo from '../store'
import { Widget } from '../types'

export const getWidget = () => (): Widget => {
  const { widget } = storeInfo.store.getState()
  return widget
}